export const EHS_STATS = {
  daysSinceLastLti: 142,
  lastLtiDate: '2026-01-21',
  safetyAuditsPassed: 28,
  pendingMedicalRenewals: 7,
  pendingHazmatRenewals: 4,
};

export const SEVERITY = {
  critical: {
    label: 'Critical',
    className: 'bg-red-500/15 text-red-700 ring-red-500/35',
  },
  major: {
    label: 'Major',
    className: 'bg-orange-500/15 text-orange-700 ring-orange-500/35',
  },
  minor: {
    label: 'Minor',
    className: 'bg-yellow-500/15 text-yellow-700 ring-yellow-500/35',
  },
};

export const INCIDENT_STATUS = {
  open: {
    label: 'Open',
    className: 'bg-red-50 text-red-700 ring-red-500/25',
  },
  investigating: {
    label: 'Investigating',
    className: 'bg-amber-50 text-amber-700 ring-amber-500/25',
  },
  closed: {
    label: 'Closed',
    className: 'bg-emerald-50 text-emerald-700 ring-emerald-500/25',
  },
};

export const ACTIVE_INCIDENTS = [
  {
    id: 'INC-2026-041',
    severity: 'critical',
    dateTime: '2026-06-12 09:14 GST',
    description: 'Tyre blowout on E11 near Al Dhaid — DXB-T-5510',
    actionTaken: 'Recovery truck dispatched · Lane closure coordinated with RTA',
    status: 'investigating',
  },
  {
    id: 'INC-2026-040',
    severity: 'major',
    dateTime: '2026-06-12 07:45 GST',
    description: 'Spillage near Jebel Ali depot loading bay — diesel trace (~15L)',
    actionTaken: 'Spill kit deployed · Soil containment barriers installed · ADNOC notified',
    status: 'open',
  },
  {
    id: 'INC-2026-039',
    severity: 'minor',
    dateTime: '2026-06-11 22:30 GST',
    description: 'Minor mechanical failure — brake sensor warning SHJ-T-3305',
    actionTaken: 'Vehicle held at Musaffah workshop · Preventive inspection scheduled',
    status: 'investigating',
  },
  {
    id: 'INC-2026-038',
    severity: 'major',
    dateTime: '2026-06-11 16:20 GST',
    description: 'HAZMAT documentation mismatch at Fujairah terminal gate',
    actionTaken: 'Load held pending customs re-verification · Compliance officer assigned',
    status: 'open',
  },
  {
    id: 'INC-2026-037',
    severity: 'minor',
    dateTime: '2026-06-11 11:05 GST',
    description: 'Near-miss — reversing incident in Hamriyah depot yard',
    actionTaken: 'CCTV review completed · Driver refresher briefing issued',
    status: 'closed',
  },
  {
    id: 'INC-2026-036',
    severity: 'critical',
    dateTime: '2026-06-10 14:52 GST',
    description: 'Driver fatigue alert — AUH-T-1188 exceeded continuous drive limit',
    actionTaken: 'Mandatory rest stop enforced · Trip paused · HSE supervisor notified',
    status: 'closed',
  },
  {
    id: 'INC-2026-035',
    severity: 'minor',
    dateTime: '2026-06-10 08:18 GST',
    description: 'PPE non-compliance during pre-trip inspection — missing safety boots',
    actionTaken: 'Driver sent for PPE kit · Inspection re-done before departure',
    status: 'closed',
  },
  {
    id: 'INC-2026-034',
    severity: 'major',
    dateTime: '2026-06-09 19:40 GST',
    description: 'Bitumen load temperature excursion during Ruwais → Musaffah transit',
    actionTaken: 'Heating unit reset · Product quality sample sent to lab',
    status: 'investigating',
  },
];

export function computeIncidentSummary(incidents = ACTIVE_INCIDENTS) {
  return {
    total: incidents.length,
    open: incidents.filter((i) => i.status === 'open').length,
    investigating: incidents.filter((i) => i.status === 'investigating').length,
    closed: incidents.filter((i) => i.status === 'closed').length,
    critical: incidents.filter((i) => i.severity === 'critical').length,
    major: incidents.filter((i) => i.severity === 'major').length,
    minor: incidents.filter((i) => i.severity === 'minor').length,
  };
}

export const EMPTY_INCIDENT_FORM = {
  severity: 'minor',
  description: '',
  actionTaken: '',
};

export function formatIncidentDateTime(date = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())} GST`;
}

export function generateIncidentId(incidents) {
  const nums = incidents.map((i) => parseInt(i.id.split('-').pop(), 10));
  const next = Math.max(0, ...nums) + 1;
  return `INC-2026-${String(next).padStart(3, '0')}`;
}
